// TabItem.js
import React, {memo, useCallback, useEffect, useMemo, useState} from 'react';
import {IconButton, ListItemText} from '@mui/material';
import { motion } from 'framer-motion';
import CachedIcon from '@mui/icons-material/Cached';
import CancelIcon from '@mui/icons-material/Cancel';
import { css, keyframes } from '@emotion/react';
import {useTranslation} from "react-i18next";

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const TabItem = ({ tab, isActive, onClick, onReload, onDelete,index ,tabsLength}) => {

    const [rotation, setRotation] = useState(0);
    const [isRotating, setIsRotating] = useState(false);
    const {t, i18n} = useTranslation();

    const handleClick = useCallback(() => {
        onClick();
    }, [onClick]);

    const itemStyles = useMemo(() => ({
        opacity: isActive ? 1 : 0.5,
        transition: 'opacity 0.2s ease',
        '&:hover': {
            color: 'white !important',
            transform: 'rotate(90deg)',
            boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            opacity: 1
        }
    }), [isActive]);


    const handleAnimationEnd = () => {
        // 动画完成后立即设置旋转度数为360度的倍数，这样视觉上看不会有变化
        if (isRotating) {
            setRotation(prev => prev % 360);
            setIsRotating(false);
        }
    };
    return (
        <motion.li

            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 0 }}
            transition={{
                type: 'tween',
                ease: 'linear',
                duration: 0.2
            }}
            className={isActive ? 'active' : ''}
            onClick={handleClick}
        >
            <div style={{ display: "flex", alignItems: 'center' }}>
                {/*<IconButton*/}
                {/*    size="small"*/}
                {/*    sx={itemStyles}*/}
                {/*    className="restart-icon"*/}
                {/*    aria-label="restart"*/}
                {/*    color="white" // 使用 'inherit' 或者选择 'default', 'primary', 'secondary'*/}
                {/*    // sx={{*/}
                {/*    //     transition: 'transform 0.2s linear, color 0.2s linear',*/}
                {/*    //     '&:hover': {*/}
                {/*    //         color: 'white !important',*/}
                {/*    //         transform: 'rotate(90deg)',*/}
                {/*    //         boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px'*/}
                {/*    //     },*/}
                {/*    // }}*/}

                {/*    onTransitionEnd={handleAnimationEnd}*/}
                {/*    onClick={(event) => {*/}
                {/*        setIsRotating(true);*/}
                {/*        setRotation(rotation + 360);*/}
                {/*        onReload(event); // 调用传入的 onReload 函数执行重载逻辑*/}

                {/*    }}*/}
                {/*>*/}
                {/*    <CachedIcon />*/}
                {/*</IconButton>*/}

                <ListItemText
                    sx={theme => ({
                        '& .MuiListItemText-primary': {
                            fontSize: isActive ? 'medium' : 'small',
                            marginRight: '5px',
                            marginLeft: '5px',
                            fontWeight: isActive ? 'bold' : 'normal',
                            whiteSpace: 'nowrap',
                        },
                        '& .MuiTypography-root': { // 直接定位到由 ListItemText 生成的文本根元素
                            transition: 'color 0.3s ease', // 添加颜色变化的过渡效果
                            '&:hover': {
                                // fontWeight:isActive ? '900' :'bold',
                                textShadow: '2px 2px 5px rgba(255, 255, 255, 0.8)'
                            }
                        }
                    })}
                    primary={t(`Sidebar.${tab.label}`)}
                />
                {
                    !(tabsLength === 1 && index ===0) &&
                    <IconButton
                        size="small"
                        color="white" // 使用 'inherit' 或者选择 'default', 'primary', 'secondary'
                        sx={{
                            '&:hover': {
                                color: 'white !important',
                                transform: 'rotate(90deg)',
                                boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px'
                            },
                            transition: 'transform 0.3s ease-in-out'
                        }}
                        aria-label="delete"
                        onClick={onDelete}
                    >
                        <CancelIcon />
                    </IconButton>
                }

            </div>
        </motion.li>
    );
};

export default TabItem;
